const analyticsColorScheme = {
  7: {
    1: '#dd3952',
    2: '#dd6556',
    3: '#dd9f60',
    4: '#ddcd67',
    5: '#9add4f',
    6: '#83dd64',
    7: '#3cdd43',
    acceptable: '#9add4f',
    unAcceptable: '#dd6556'
  },
  6: {
    1: '#dd3952',
    2: '#dd6556',
    3: '#dd9f60',
    4: '#ddcd67',
    5: '#9add4f',
    6: '#3cdd43',
    acceptable: '#9add4f',
    unAcceptable: '#dd6556'
  },
  5: {
    1: '#dd3952',
    2: '#dd6556',
    3: '#ddcd67',
    4: '#83dd64',
    5: '#3cdd43',
    acceptable: '#9add4f',
    unAcceptable: '#dd6556'
  },
  4: {
    1: '#dd3952',
    2: '#dd6556',
    3: '#9add4f',
    4: '#3cdd43',
    acceptable: '#9add4f',
    unAcceptable: '#dd6556'
  },
  3: {
    1: '#dd3952',
    2: '#1a4c8d',
    3: '#28a22e',
    acceptable: '#9add4f',
    unAcceptable: '#dd6556'
  }, 2: {
    1: '#dd3952',
    2: '#28a22e',
    acceptable: '#9add4f',
    unAcceptable: '#dd6556'
  }
};

let scoreColors = {
  1: '#960808',
  2: '#ad6706',
  3: '#b7a507',
  4: '#349438',
  5: '#6713a6',
  6: '#104779',
  7: '#2bb8cb',
}

export {
  analyticsColorScheme,
  scoreColors
}
